'use strict';

var d3 = require('d3');
var Stripes = function Stripes(d3Helper) {
  return function (yPropertyName) {
    var params, scales;
    var category20 = d3.scale.category20();
    var stripes = function stripes(container) {
      function isVisible(d) {
        return d !== 0;
      }
      var rectWidth = scales.xScale.rangeBand();
      var group = container.select('.groups').selectAll('.stack.visible');
      group.each(function (d) {
        if (d[yPropertyName] === undefined) {
          return;
        }
        var stripsGroup = d3Helper.createGroupElement(d3.select(this), 'stripes-group');
        function getCss(i) {
          if (d.css) {
            return d.css[i];
          } else {
            return '';
          }
        }
        function getFill(i) {
          if (d.fill && d.fill[i]) {
            return d.fill[i];
          }
          return getColorIndex(i);
        }
        function getColorIndex(i) {
          if (!d.css) {
            return category20(i);
          }
        }

        //remove all gap elements
        stripsGroup.selectAll('.gap').remove();

        //remove all noData elements
        stripsGroup.selectAll('.noData').remove();
        var stripesGroup = stripsGroup.selectAll('.stripe').data(d[yPropertyName]);
        stripesGroup.exit().remove();
        stripesGroup.enter().append('rect').attr('class', 'stripe');
        stripesGroup.attr({
          'y': function y(d) {
            return d < 0 ? scales.yScale(0) + 1 : scales.yScale(d);
          },
          'width': rectWidth,
          'height': function height(d) {
            return Math.abs(scales.yScale(0) - scales.yScale(d));
          },
          'class': function _class(d, i) {
            return 'stripe ' + getCss(i);
          }
        });
        stripesGroup.classed({
          'is-visible': isVisible
        });
        stripesGroup.style({
          'fill': function fill(d, i) {
            return getFill(i);
          }
        });
      });
    };
    stripes.params = function (value) {
      params = value;
      return stripes;
    };
    stripes.scales = function (value) {
      scales = value;
      return stripes;
    };
    return stripes;
  };
};
Stripes.$inject = ['d3Helper'];
module.exports = Stripes;